<div class="front-wrap">
  <div class="front-store-content">
    <div class="container">
      <div class="dash-head">
        <h2>WishList</h2>
      </div>

      <mat-card class="spg-mat-card mat-card-cmn" *ngIf="wishListItem?.length == 0">
        <mat-card-header>
          <mat-card-title>MY WISHLIST (0) </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="text-center">
            <img src="assets/img/emptycart.PNG">
            <span> Your wishlist is empty</span>
            <a [routerLink]="['/',parentRouteParam]"> Continue Shopping</a>
          </div>
        </mat-card-content>
      </mat-card>
      <div class="wshlist-ui-tbl" *ngIf="wishListItem?.length > 0">
        <div class="card-body">
          <div class="sp-crt-hd">
            <div class="row customcssfortableHeader">
              <div class="col-12 col-sm-12 col-md-2 text-center">
                <h4 class="product-name"><strong>&nbsp;</strong></h4>
              </div>
              <div class="col-12 text-sm-center col-sm-12 text-md-left col-md-5">
                <h4 class="product-name"><strong>Product </strong></h4>
              </div>
              <div class="col-12 col-sm-12 text-sm-center col-md-5 row">
                <div class="col-3 col-sm-3 col-md-4 text-left">
                  <h4><strong>Total Price</strong></h4>
                </div>
                <div class="col-4 col-sm-4 col-md-4 text-center">

                </div>
                <div class="col-2 col-sm-2 col-md-4 text-center">
                  <h4><strong>Remove</strong></h4>
                </div>
              </div>
            </div>
          </div>
          <!-- PRODUCT -->
          <!-- <span *ngIf="wishListItem.length == 0" class=" col-12 col-sm-12 col-md-2 text-center">Your wishlist is empty</span> -->
          <div *ngFor="let wish of wishListItem" class="crt-rw-rpt">
            <div class="row">
              <div *ngIf="!wish.IsWareHouseProduct" class="col-12 col-sm-12 col-md-2 text-center">
                <img [ngStyle]="{'cursor': userRole === 'EndUser' ? 'pointer' : 'default'}" (click)="userRole === 'SuperAdmin' ? '': fn_ViewProduct(wish.ProductId, wish.DesignId, 1)"
                     src="{{imgBaseURL + wish.ImageName}}" alt="store image">
              </div>
              <div *ngIf="wish.IsWareHouseProduct" class="crt-rw-rpt">
                <img [ngStyle]="{'cursor': userRole === 'EndUser' ? 'pointer' : 'default'}" (click)="userRole === 'SuperAdmin' ? '': fn_ViewProduct(wish.ProductId, wish.DesignId, 1)"
                     src="{{imgWareHouseBaseURL + wish.PngRelativeUrlWithProduct}}" alt="store image">
              </div>
              <div class="col-12 text-sm-center col-sm-12 text-md-left col-md-5">
                <p>
                  <mat-label class="product-name" [ngStyle]="{'cursor': userRole === 'EndUser' ? 'pointer' : 'default'}" (click)="userRole === 'SuperAdmin' ? '': fn_ViewProduct(wish.ProductId, wish.DesignId, 1)">
                    <strong>Product Name:</strong>
                    {{wish.DesignName}}
                  </mat-label><br>
                  <strong>Color Name:</strong> {{wish.ColorName}} <br />
                  <strong>Size:</strong> {{wish.SizeName}} <br />
                  <strong>Quantity:</strong> {{wish.Quantity}}	<br />
                  <strong>	Price:</strong> {{wish.TotalPrice| currency:'USD':'symbol':'1.2-2'}} <span> per piece</span>
                </p>
                <!-- <h6><strong>Size:${{wish.SizeName}}</strong></h6>	 -->
              </div>
              <div class="col-12 col-sm-12 text-sm-center col-md-5 row">
                <div class="col-3 col-sm-3 col-md-4  text-left">
                  <h6><strong>{{ wish.TotalPrice * wish.Quantity| currency:'USD':'symbol':'1.2-4'}}</strong></h6>
                </div>
                <div class="col-4 col-sm-4 col-md-4">
                  <a class="cart-btn mat-btn" (click)="fn_AddToCart(wish)">Add to cart</a>
                </div>
                <div class="col-2 col-sm-2 col-md-4 text-center">
                  <a class="cart-rmv" style="cursor:pointer" (click)="fn_DeleteFromWishList(wish.WishListId)">&times;</a>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
